import { render, staticRenderFns } from "./BrandShare.vue?vue&type=template&id=48bff385&"
import script from "./BrandShare.vue?vue&type=script&lang=js&"
export * from "./BrandShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports